/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Calculation_IntroInputs */

const en_matching_score_calculation_intro = /** @type {(inputs: Matching_Score_Calculation_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Based on the information in your profile, we are now calculating how well your qualifications match the position. Please wait a moment.`)
};

const de_matching_score_calculation_intro = /** @type {(inputs: Matching_Score_Calculation_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Grundlage der Angaben in deinem Profil berechnen wir jetzt, wie gut deine Qualifikationen zur Stelle passen. Bitte habe einen Moment Geduld.`)
};

/**
* | output |
* | --- |
* | "Based on the information in your profile, we are now calculating how well your qualifications match the position. Please wait a moment." |
*
* @param {Matching_Score_Calculation_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_calculation_intro = /** @type {((inputs?: Matching_Score_Calculation_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Calculation_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_calculation_intro(inputs)
	return en_matching_score_calculation_intro(inputs)
});